<template>
  <v-icon
    :color="color"
    :size="size"
  >
    <v-svg-icon
      :color="color"
      :icon="iconPath"
      :size="size"
      tag="i"
    />
  </v-icon>
</template>

<script setup lang="ts">
import { loadIcon } from '@iconify/vue';

const props = defineProps<{
  icon: string
  size?: string | number
  color?: string
}>();
const appConfig = useAppConfig();
const state = useState<Record<string, string>>('icon-svg-paths', () => ({}));
const iconName = computed(() => (appConfig.nuxtIcon.aliases || {})[props.icon] || props.icon);
const loadIconToState = async (iconName: string) => {
  if (!state.value?.[iconName]) {
    const icon = await loadIcon(iconName as string).catch(() => undefined);
    state.value[iconName] = icon?.body.replace(/<path.*d\="/, '').replace('"/>', '') || '';
  }
};

// Load the icon when `iconName` is initially provided
await loadIconToState(iconName.value);
// Watch for changes to `iconName` and reload icon
watch(iconName, loadIconToState);

const iconPath = computed(() => state.value[iconName.value]);
</script>

<style scoped>
.v-icon {
  transform: translateY(2px);
}
</style>
